"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
function LoginForm(props) {
    const handleSubmitForm = (e) => {
        const { onSubmit } = props;
        //console.log("handing submit");
        if (typeof onSubmit !== 'function') {
            return;
        }
        e.preventDefault();
        const form = e.target;
        if (form.checkValidity()) {
            onSubmit(form);
        }
    };
    const getWaitingIndicator = () => {
        const { waiting } = props;
        if (waiting) {
            return (react_1.default.createElement("div", { className: "login-form-cover" },
                react_1.default.createElement("img", { src: "/images/login_loading_indicator.gif" })));
        }
        return null;
    };
    const { title, footer, children } = props;
    return (react_1.default.createElement("div", { className: "login-form-page" },
        react_1.default.createElement("div", { className: "login-form-container" },
            react_1.default.createElement("div", { className: "login-form-header" }),
            react_1.default.createElement("div", { className: "login-form-body" },
                react_1.default.createElement("form", { className: "login-form", onSubmit: e => handleSubmitForm(e), acceptCharset: "utf-8", method: props.method, action: props.action },
                    react_1.default.createElement("div", { className: "row row-10m login-form-title" },
                        react_1.default.createElement("div", { className: "col-xs-12" },
                            react_1.default.createElement("h2", { className: "text-center" }, title))),
                    children),
                react_1.default.createElement("div", { className: "footer" }, footer),
                getWaitingIndicator()))));
}
LoginForm.propTypes = {
    waiting: prop_types_1.default.bool,
    title: prop_types_1.default.string,
    footer: prop_types_1.default.object,
};
exports.default = LoginForm;
